'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spotlightTreeEngine = exports.size = undefined;

var _or = require('ramda/src/or');

var _or2 = _interopRequireDefault(_or);

var _and = require('ramda/src/and');

var _and2 = _interopRequireDefault(_and);

var _filter = require('ramda/src/filter');

var _filter2 = _interopRequireDefault(_filter);

var _toLower = require('ramda/src/toLower');

var _toLower2 = _interopRequireDefault(_toLower);

var _contains = require('ramda/src/contains');

var _contains2 = _interopRequireDefault(_contains);

var _prop = require('ramda/src/prop');

var _prop2 = _interopRequireDefault(_prop);

var _is = require('ramda/src/is');

var _is2 = _interopRequireDefault(_is);

var _any = require('ramda/src/any');

var _any2 = _interopRequireDefault(_any);

var _length = require('ramda/src/length');

var _length2 = _interopRequireDefault(_length);

var _values = require('ramda/src/values');

var _values2 = _interopRequireDefault(_values);

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// length for either arrays or objects
var size = exports.size = (0, _pipe2.default)(_values2.default, _length2.default);

// spotlight engine
var spotlightHandler = function spotlightHandler(spotlight) {
  return function (item) {
    return (0, _any2.default)(function (field) {
      var itemValue = (0, _is2.default)(Function, field.accessor) ? field.accessor(item) : (0, _prop2.default)(field.accessor, item);
      return (0, _contains2.default)((0, _toLower2.default)(spotlight.term), (0, _toLower2.default)(itemValue));
    })((0, _values2.default)((0, _filter2.default)((0, _prop2.default)('isSelected'))(spotlight.fields)));
  };
};

var spotlightTreeEngine = exports.spotlightTreeEngine = function spotlightTreeEngine(spotlight) {
  return function (items) {
    var recurse = function recurse(nodes) {
      return (0, _filter2.default)(function (node) {
        var nodeIsValid = spotlightHandler(spotlight)(node);
        if (!(0, _is2.default)(Array, node.childNodes)) return nodeIsValid;
        var childrenAreValid = (0, _and2.default)((0, _is2.default)(Array, node.childNodes), (0, _any2.default)(function (n) {
          return !!n;
        })(recurse(node.childNodes)));
        return (0, _or2.default)(nodeIsValid, childrenAreValid);
      })(nodes);
    };

    if (!spotlight.term) return items;
    return recurse(items);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/utils.js
// module id = 1019
// module chunks = 0